// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectLocationDescriptionQueryResult, selectLocationDescriptionsPageLoading, selectLocationDescriptionsShowInitWaitingMessage} from '../_selectors/location-description.selectors';

export class LocationDescriptionsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectLocationDescriptionsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectLocationDescriptionsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectLocationDescriptionQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
